import { EPostsActions, PostActions } from '../actions/posts.actions';
import { initialLinkedPostsState, LinkedPostsState } from '../states/linked-posts.state';
import { initialPostsState, PostsState } from '../states/posts.state';

export function linkedPostsReducers(
    state = initialLinkedPostsState,
    action: PostActions
): LinkedPostsState {
    switch (action.type) {
        case EPostsActions.GetLinkedPostSuccess: {
            return {
                ...state,
                linkedPosts: action.payload
            };
        }

        case EPostsActions.GetLinkedPostFailure: {
            return {
                ...state,
                linkedPosts: null
            };
        }

        default:
            return state;
    }
}
